import { toast } from "react-hot-toast";

/**
 * Handles error responses, logs them, and shows a toast.
 * Supports string, array, and object error formats.
 * @param {any} error - The error object (from axios or fetch).
 */
export function errorHandler(error) {

  let message = "Something went wrong. Please try again.";
  if (error?.response?.data) {
    const data = error.response.data;
    if (Array.isArray(data.message)) {
      message = data.message.join(", ");
    } else if (typeof data.message === "string") {
      message = data.message;
    } else if (typeof data === "string") {
      message = data;
    } else if (data.errors && Array.isArray(data.errors)) {
      message = data.errors.map(e => e.message || e).join(", ");
    }
  } else if (error?.message) {
    message = error.message;
  }
  toast.error(message);
}